/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never;
    };
import type * as Types from './graphql.schema-types';

import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export * from './graphql.schema-types';
export type LookBookProductFragmentForClientFragment = {
  config: string | null;
  created: number | null;
  deleted: boolean | null;
  label: string | null;
  lookBookProductConfigId: string | null;
  sent: boolean | null;
  sentWhen: number | null;
  thumb: string | null;
  cost: Array<number | null> | null;
  count: number | null;
  personalizationConfig: string | null;
  hasPersonalization: boolean | null;
};

export type LookDetailsBookForClientFragmentFragment = {
  labs: Array<string | null> | null;
  lookBookId: string | null;
  spreadsCount: number | null;
  occasion: Types.LookBookOccasionForClient | null;
  configs: Array<{
    config: string | null;
    created: number | null;
    deleted: boolean | null;
    label: string | null;
    lookBookProductConfigId: string | null;
    sent: boolean | null;
    sentWhen: number | null;
    thumb: string | null;
    cost: Array<number | null> | null;
    count: number | null;
    personalizationConfig: string | null;
    hasPersonalization: boolean | null;
  } | null> | null;
  welcomeMessage: Array<{
    language: string | null;
    text: string | null;
  } | null> | null;
  postOrderMessage: Array<{
    language: string | null;
    text: string | null;
  } | null> | null;
  decorationPreConfig: {
    connector: string | null;
    date: string | null;
    firstName: string | null;
    secondName: string | null;
    decorationPreConfigForClientId: string | null;
  } | null;
};

export type GetMineLookBookDetailsForClientQueryVariables = Exact<{
  lookBookId: string;
}>;

export type GetMineLookBookDetailsForClientQuery = {
  lookBookDetailsForClient: {
    labs: Array<string | null> | null;
    lookBookId: string | null;
    spreadsCount: number | null;
    occasion: Types.LookBookOccasionForClient | null;
    configs: Array<{
      config: string | null;
      created: number | null;
      deleted: boolean | null;
      label: string | null;
      lookBookProductConfigId: string | null;
      sent: boolean | null;
      sentWhen: number | null;
      thumb: string | null;
      cost: Array<number | null> | null;
      count: number | null;
      personalizationConfig: string | null;
      hasPersonalization: boolean | null;
    } | null> | null;
    welcomeMessage: Array<{
      language: string | null;
      text: string | null;
    } | null> | null;
    postOrderMessage: Array<{
      language: string | null;
      text: string | null;
    } | null> | null;
    decorationPreConfig: {
      connector: string | null;
      date: string | null;
      firstName: string | null;
      secondName: string | null;
      decorationPreConfigForClientId: string | null;
    } | null;
  } | null;
};

export type UpdateProductThumbOrLabelMutationVariables = Exact<{
  lookBookProductConfigId: string;
  lookBookId: string;
  update: Types.LookBookProductConfigUpdate;
}>;

export type UpdateProductThumbOrLabelMutation = {
  updateLookBookProductConfigForClient: { status: boolean | null } | null;
};

export type UpdateLookBookProductConfigMutationVariables = Exact<{
  lookBookProductConfigId: string;
  lookBookId: string;
  update: Types.LookBookProductConfigUpdate;
  productsInPlay: Array<string | null | undefined> | string;
  valueMap: string;
  personalizationConfig: string;
  hasPersonalization: boolean;
}>;

export type UpdateLookBookProductConfigMutation = {
  updateLookBookProductConfigForClient: { status: boolean | null } | null;
};

export type InsertProductConfigMutationVariables = Exact<{
  lookBookId: string;
  label: string;
  lookBookProductConfigId: string;
}>;

export type InsertProductConfigMutation = {
  insertLookBookProductConfigForClient: {
    config: string | null;
    created: number | null;
    deleted: boolean | null;
    label: string | null;
    lookBookProductConfigId: string | null;
    sent: boolean | null;
    sentWhen: number | null;
    thumb: string | null;
    cost: Array<number | null> | null;
    count: number | null;
    personalizationConfig: string | null;
    hasPersonalization: boolean | null;
  } | null;
};

export type ProductFragment = {
  availableOnOccasion: Array<Types.SessionOccasion | null> | null;
  composedImages: string | null;
  config: string | null;
  configurationImages: string | null;
  deliveryTime: number | null;
  hasWizard: boolean | null;
  imagesRequired: boolean | null;
  name: string | null;
  productId: string | null;
  showDeliveryTime: boolean | null;
  status: boolean | null;
  type: Types.ProductType | null;
  sortOrder: number | null;
  organizationId: string | null;
  description: Array<{
    language: string | null;
    text: string | null;
  } | null> | null;
  price: Array<{ code: string | null; price: number | null } | null> | null;
  requiredImages: { max: number | null; min: number | null } | null;
};

export type GetProductsForLabQueryVariables = Exact<{
  organizationId: string;
  lookBookId: string;
}>;

export type GetProductsForLabQuery = {
  getProductsForLab: Array<{
    availableOnOccasion: Array<Types.SessionOccasion | null> | null;
    composedImages: string | null;
    config: string | null;
    configurationImages: string | null;
    deliveryTime: number | null;
    hasWizard: boolean | null;
    imagesRequired: boolean | null;
    name: string | null;
    productId: string | null;
    showDeliveryTime: boolean | null;
    status: boolean | null;
    type: Types.ProductType | null;
    sortOrder: number | null;
    organizationId: string | null;
    description: Array<{
      language: string | null;
      text: string | null;
    } | null> | null;
    price: Array<{ code: string | null; price: number | null } | null> | null;
    requiredImages: { max: number | null; min: number | null } | null;
  } | null> | null;
};

export type GetZalamoStandaloneAlbumQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetZalamoStandaloneAlbumQuery = {
  zalamoStandaloneAlbum: {
    availableOnOccasion: Array<Types.SessionOccasion | null> | null;
    composedImages: string | null;
    config: string | null;
    configurationImages: string | null;
    deliveryTime: number | null;
    hasWizard: boolean | null;
    imagesRequired: boolean | null;
    name: string | null;
    productId: string | null;
    showDeliveryTime: boolean | null;
    status: boolean | null;
    type: Types.ProductType | null;
    sortOrder: number | null;
    organizationId: string | null;
    description: Array<{
      language: string | null;
      text: string | null;
    } | null> | null;
    price: Array<{ code: string | null; price: number | null } | null> | null;
    requiredImages: { max: number | null; min: number | null } | null;
  } | null;
};

export type SendToPhotographerMutationVariables = Exact<{
  lookBookId: string;
  expectedCost: number;
}>;

export type SendToPhotographerMutation = {
  sendToPhotographer: { status: boolean | null } | null;
};

export type GetDecorationDetailsForClientQueryVariables = Exact<{
  decorationId: string;
}>;

export type GetDecorationDetailsForClientQuery = {
  getDecorationForClient: {
    decorationForClientId: string | null;
    fields: Array<{
      decorationFieldId: string | null;
      types: Array<Types.DecorationFieldType | null> | null;
    } | null> | null;
  } | null;
};

export const LookBookProductFragmentForClientFragmentDoc = gql`
  fragment LookBookProductFragmentForClient on LookBookProductConfig {
    config
    created
    deleted
    label
    lookBookProductConfigId
    sent
    sentWhen
    thumb
    cost
    count
    personalizationConfig
    hasPersonalization
  }
`;
export const LookDetailsBookForClientFragmentFragmentDoc = gql`
  fragment LookDetailsBookForClientFragment on LookBookDetailsForClient {
    configs {
      ...LookBookProductFragmentForClient
    }
    labs
    lookBookId
    spreadsCount
    welcomeMessage {
      language
      text
    }
    postOrderMessage {
      language
      text
    }
    occasion
    decorationPreConfig {
      connector
      date
      firstName
      secondName
      decorationPreConfigForClientId
    }
  }
  ${LookBookProductFragmentForClientFragmentDoc}
`;
export const ProductFragmentDoc = gql`
  fragment Product on Product {
    availableOnOccasion
    composedImages
    config
    configurationImages
    deliveryTime
    description {
      language
      text
    }
    hasWizard
    imagesRequired
    name
    price {
      code
      price
    }
    productId
    requiredImages {
      max
      min
    }
    showDeliveryTime
    status
    type
    sortOrder
    organizationId
  }
`;
export const GetMineLookBookDetailsForClientDocument = gql`
  query getMineLookBookDetailsForClient($lookBookId: ID!) {
    lookBookDetailsForClient(lookBookId: $lookBookId) {
      ...LookDetailsBookForClientFragment
    }
  }
  ${LookDetailsBookForClientFragmentFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class GetMineLookBookDetailsForClientGQL extends Apollo.Query<
  GetMineLookBookDetailsForClientQuery,
  GetMineLookBookDetailsForClientQueryVariables
> {
  document = GetMineLookBookDetailsForClientDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const UpdateProductThumbOrLabelDocument = gql`
  mutation updateProductThumbOrLabel(
    $lookBookProductConfigId: ID!
    $lookBookId: ID!
    $update: LookBookProductConfigUpdate!
  ) {
    updateLookBookProductConfigForClient(
      lookBookProductConfigId: $lookBookProductConfigId
      update: $update
      lookBookId: $lookBookId
    ) {
      status
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class UpdateProductThumbOrLabelGQL extends Apollo.Mutation<
  UpdateProductThumbOrLabelMutation,
  UpdateProductThumbOrLabelMutationVariables
> {
  document = UpdateProductThumbOrLabelDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const UpdateLookBookProductConfigDocument = gql`
  mutation updateLookBookProductConfig(
    $lookBookProductConfigId: ID!
    $lookBookId: ID!
    $update: LookBookProductConfigUpdate!
    $productsInPlay: [ID]!
    $valueMap: String!
    $personalizationConfig: String!
    $hasPersonalization: Boolean!
  ) {
    updateLookBookProductConfigForClient(
      lookBookProductConfigId: $lookBookProductConfigId
      update: $update
      lookBookId: $lookBookId
      productsInPlay: $productsInPlay
      valueMap: $valueMap
      personalizationConfig: $personalizationConfig
      hasPersonalization: $hasPersonalization
    ) {
      status
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class UpdateLookBookProductConfigGQL extends Apollo.Mutation<
  UpdateLookBookProductConfigMutation,
  UpdateLookBookProductConfigMutationVariables
> {
  document = UpdateLookBookProductConfigDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const InsertProductConfigDocument = gql`
  mutation insertProductConfig(
    $lookBookId: ID!
    $label: String!
    $lookBookProductConfigId: ID!
  ) {
    insertLookBookProductConfigForClient(
      lookBookId: $lookBookId
      label: $label
      lookBookProductConfigId: $lookBookProductConfigId
    ) {
      ...LookBookProductFragmentForClient
    }
  }
  ${LookBookProductFragmentForClientFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class InsertProductConfigGQL extends Apollo.Mutation<
  InsertProductConfigMutation,
  InsertProductConfigMutationVariables
> {
  document = InsertProductConfigDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetProductsForLabDocument = gql`
  query getProductsForLab($organizationId: ID!, $lookBookId: ID!) {
    getProductsForLab(
      organizationId: $organizationId
      lookBookId: $lookBookId
    ) {
      ...Product
    }
  }
  ${ProductFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class GetProductsForLabGQL extends Apollo.Query<
  GetProductsForLabQuery,
  GetProductsForLabQueryVariables
> {
  document = GetProductsForLabDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetZalamoStandaloneAlbumDocument = gql`
  query getZalamoStandaloneAlbum {
    zalamoStandaloneAlbum {
      ...Product
    }
  }
  ${ProductFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class GetZalamoStandaloneAlbumGQL extends Apollo.Query<
  GetZalamoStandaloneAlbumQuery,
  GetZalamoStandaloneAlbumQueryVariables
> {
  document = GetZalamoStandaloneAlbumDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const SendToPhotographerDocument = gql`
  mutation sendToPhotographer($lookBookId: ID!, $expectedCost: Int!) {
    sendToPhotographer(lookBookId: $lookBookId, expectedCost: $expectedCost) {
      status
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class SendToPhotographerGQL extends Apollo.Mutation<
  SendToPhotographerMutation,
  SendToPhotographerMutationVariables
> {
  document = SendToPhotographerDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetDecorationDetailsForClientDocument = gql`
  query getDecorationDetailsForClient($decorationId: ID!) {
    getDecorationForClient(decorationId: $decorationId) {
      decorationForClientId
      fields {
        decorationFieldId
        types
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetDecorationDetailsForClientGQL extends Apollo.Query<
  GetDecorationDetailsForClientQuery,
  GetDecorationDetailsForClientQueryVariables
> {
  document = GetDecorationDetailsForClientDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
